import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const organizationService = {
    getOrganizations: async (params: { page?: number; limit?: number; name?: string }) => {
      const token = localStorage.getItem("token")

        const response = await axios.get(`${API_BASE_URL}/org`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params
        });
        return response.data;
    },

    getAllOrganizations: async () => {
      const token = localStorage.getItem("token")

        const response = await axios.get(`${API_BASE_URL}/org/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        return response.data;
    },
  
    getOrganizationById: async (id: string) => {
      const token = localStorage.getItem("token")

        const response = await axios.get(`${API_BASE_URL}/org/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },
  
    createOrganization: async (data: {
      org_name: string,
      org_logo: string,
      org_address: string,
    }) => {
      const token = localStorage.getItem("token")

        const response = await axios.post(`${API_BASE_URL}/org`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return response.data;
    },
  
    updateOrganization: async (
      id: string,
      data: {
        org_name: string,
        org_logo: string,
        org_address: string,
      }
    ) => {
      const token = localStorage.getItem("token")

        const response = await axios.put(`${API_BASE_URL}/org/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return response.data;
    },
  
    deleteOrganization: async (id: string) => {
      const token = localStorage.getItem("token")
      
        const response = await axios.delete(`${API_BASE_URL}/org/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        return response.data;
    }
  };